import type { SearchExperiencePreference } from './searchExperiencePreference.types'
export const SEARCH_EXPERIENCE_COOKIE = 'awaze_beta_search_experience'

const ONE_DAY_SECONDS = 60 * 60 * 24

/** Set per environment in the infra task definitions; anything but "true" disables. */
export const isSearchBetaEnabled = (value: string | undefined): boolean =>
  value === 'true'

/** A preference chooses a layout; it must never grant rollout eligibility. */
export const isSearchBetaEligible = ({
  enabled,
  brand,
  locale,
  brands = 'cottages.com',
}: {
  enabled: boolean
  brand: string
  locale: string
  brands?: string
}): boolean =>
  enabled &&
  /^en(?:-|$)/i.test(locale) &&
  brands
    .split(',')
    .map((value) => value.trim())
    .includes(brand)

export const isSearchBetaAvailable = (
  searchBeta: string | string[] | undefined,
  preferenceCookie: string | undefined,
): boolean =>
  searchBeta === 'true' ||
  preferenceCookie === 'beta' ||
  preferenceCookie === 'traditional'

export const parseSearchExperiencePreference = (
  value: string | undefined,
): SearchExperiencePreference => (value === 'beta' ? 'beta' : 'traditional')

export const persistSearchExperiencePreference = (
  preference: SearchExperiencePreference,
): void => {
  if (globalThis.window === undefined) return

  const maxAge = preference === 'beta' ? ONE_DAY_SECONDS * 180 : ONE_DAY_SECONDS
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${SEARCH_EXPERIENCE_COOKIE}=${preference}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`
}

export type { SearchExperiencePreference } from './searchExperiencePreference.types'
